import type { Content } from "@prismicio/client"
import type { SliceComponentProps } from "@prismicio/react"

import { CTA } from "@bounce/web-components"

/**
 * Props for `CtaBanner`.
 */
export type CtaBannerSliceProps = SliceComponentProps<Content.CtaBannerSlice>

/**
 * Component for "CtaBanner" Slices.
 */
const CtaBannerSlice = ({ slice }: CtaBannerSliceProps): React.JSX.Element => {
  return <CTA {...slice.primary} />
}

export default CtaBannerSlice
